module.exports = __webpack_public_path__ + "static/img/examination.c6e6b217.svg";